// @ts-nocheck

import { request } from '../../../../context';
import type { ApiOptions } from '../../../../context';
import type {
    PostReviewIntelligentPartnerAiTestBody,
    BaseResponseIntelligentPartnerTrainingWords,
} from '../../../../types';

/**
 * ai测试人机练习
 *
 * @export
 * @tags 智能陪练-对话流程(节点, 全局配置, 客户画像)
 * @link [POST] /review/intelligentPartner/ai/test
 */
export function postReviewIntelligentPartnerAiTest(
    data: PostReviewIntelligentPartnerAiTestBody
): Promise<BaseResponseIntelligentPartnerTrainingWords>;
export function postReviewIntelligentPartnerAiTest(
    data: PostReviewIntelligentPartnerAiTestBody,
    options: ApiOptions<never, never>
): Promise<BaseResponseIntelligentPartnerTrainingWords>;
export function postReviewIntelligentPartnerAiTest(
    data: PostReviewIntelligentPartnerAiTestBody,
    options?: ApiOptions<never, never>
): Promise<BaseResponseIntelligentPartnerTrainingWords> {
    return request<PostReviewIntelligentPartnerAiTestBody, never, never>(
        '/review/intelligentPartner/ai/test',
        {
            ...options,
            data,
            method: 'post',
            __$requestCalleeName: 'postReviewIntelligentPartnerAiTest',
        }
    );
}

export const meta = [
    {
        tags: ['智能陪练-对话流程(节点, 全局配置, 客户画像)'],
        path: '/review/intelligentPartner/ai/test',
        method: 'post',
    },
];
